import { render, staticRenderFns } from "./edit_proxy.vue?vue&type=template&id=2da29059"
import script from "./edit_proxy.vue?vue&type=script&lang=ts"
export * from "./edit_proxy.vue?vue&type=script&lang=ts"
import style0 from "./edit_proxy.vue?vue&type=style&index=0&id=2da29059&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports